import "./Spinner.css";
import { siteTexts } from "../i18n/siteTexts";

type SpinnerProps = {
  label?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
};

function joinClassNames(...classes: Array<string | undefined>) {
  return classes.filter(Boolean).join(" ");
}

export default function Spinner({
  label = siteTexts.common.loading,
  size = "md",
  className,
}: SpinnerProps) {
  return (
    <span
      className={joinClassNames("spinner", `spinner--${size}`, className)}
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <span className="spinner__circle" aria-hidden="true" />
    </span>
  );
}
